{
	"title": "中泽 🐇🥕🐰",
	"description": "🐇🥕🐰",
	"buttons": {
		"fullscreen": "全屏",
		"achievements": "成就",
		"reset": "重置",
		"language": "语言"
	},
	"achievements": {
		"title": "成就",
		"noAchievements": "还没有获得任何成就。继续点击！",
		"unlocked": "解锁成就：{{message}}",
		"progress": "{{progress}}%",
		"beginner": "🎯 新手兔子",
		"carrotSnatcher": "🥕 蔬菜大盗",
		"bunnyBerserker": "😡 狂暴兔子",
		"hopPunk": "🎸 朋克兔子",
		"bunnyNinja": "🥷 无声致命毛球",
		"expert": "🌟 跳跃专家",
		"master": "👑 胡萝卜之王",
		"carrotpocalypse": "🥕 菜园毁灭者",
		"bunnyOverlord": "😈 兔子洞霸主",
		"chaosHare": "🌪️ 混沌特工",
		"carrotCultist": "⛪ 胡萝卜教大祭司",
		"bunnyberryPie": "🥧 幻觉派大师",
		"rabbitHole": "🕳️ 量子隧道挖掘机",
		"moonRabbit": "🌙 月兔捣药",
		"bunnyDoom": "💀 兔子末日使者",
		"carrotNuke": "☢️ 核胡萝卜持有者",
		"bunnyMatrix": "🤖 兔子矩阵故障",
		"cosmicHare": "🌌 宇宙之兔觉醒",
		"warrenSingularity": "🕳️ 兔子洞奇点达成",
		"eternalBunny": "♾️ 永恒之兔"
	},
	"messages": {
		"prophecy": "古老的点击预言开始展开...",
		"cosmic": "宇宙点击者会为你的进步感到骄傲！",
		"astral": "点击声在星界中回荡...",
		"speaking": "等等...你听到了吗？点击在和我说话...",
		"ancient": "你的点击与远古力量共鸣！",
		"sages": "点击贤者低语着你的潜力...",
		"demons": "看啊！点击恶魔从沉睡中醒来！",
		"veil": "你的点击刺穿了现实的面纱！",
		"spirits": "点击之灵随着你的节奏起舞...",
		"council": "点击大议会注意到了你的奉献",
		"primordial": "你的点击唤醒了原始力量！",
		"void": "点击虚空回望着你...",
		"runes": "古老的点击符文因你的力量而发光！",
		"beast": "三三三 - 点击野兽的数字",
		"prophets": "点击先知歌颂着你的到来！",
		"dimensions": "你的点击在维度间回响...",
		"portal": "你的点击打开了通往点击维度的传送门！",
		"sacrifice": "古老的点击之神要求更多祭品",
		"jackpot": "大奖！点击赌场欢迎它的最新冠军！",
		"unmatched": "你的点击力量无人能及!",
		"reality": "现实本身在你的点击意志下弯曲！",
		"elite": "你已成为精英点击大师",
		"power": "你的点击力量等级超过1500！",
		"devils": "点击恶魔在你的力量前俯首",
		"lucky": "幸运点击流淌在你的血液中",
		"dynasty": "点击王朝认可你的至高无上",
		"twoThousand": "两千次纯粹力量的点击！",
		"quartet": "点击四重奏的预言已实现",
		"transcend": "你的点击超越了凡人的理解",
		"constellation": "点击星座为你的荣耀而排列",
		"destiny": "命运的三千次点击",
		"triforce": "三重点击力量觉醒！",
		"fortune": "命运青睐执着的点击者",
		"newDimensions": "你的点击力量达到新的维度",
		"quartet2": "四重点击四重奏和谐共鸣",
		"threshold": "站在点击神性的门槛",
		"ultimate": "五千次终极力量的点击！",
		"force": "五指点击力量任你驱使",
		"underworld": "点击冥界加冕你为王",
		"maxJackpot": "达到最大点击大奖",
		"infinite": "无限点击力量！",
		"godhood": "你已提升为点击之神",
		"burrow": "你挖得比任何兔子都深...",
		"warren": "伟大的兔子洞承认你的存在...",
		"thump": "你每一次跺脚都让大地颤抖！",
		"darkWarren": "黑暗兔子洞为你打开了大门...",
		"ears": "你的耳朵越来越长...现在你能听到一切...",
		"carrotThrone": "胡萝卜王座在你面前显现...",
		"onesAlignment": "所有的一都对齐了 - 兔子洞频率共振！",
		"moonSummon": "月兔隔着虚空听到了你的呼唤...",
		"edgeOfForever": "你站在永恒的边缘...耳朵微微颤动...",
		"beyondTheVeil": "面纱之外，所有兔子洞合为一体...",
		"sequence": "1-2-3-4-5...神圣的跳跃序列完成了！",
		"hyperElite": "超级精英兔子状态解锁 🐇🐇🐇",
		"eventHorizon": "越过宇宙兔子洞的事件视界...",
		"matrixAwakens": "兔子洞矩阵出现故障...你看到了现实背后的胡萝卜",
		"luckyForever": "每一只爪子，每一次跳跃，每一次颤动...永远被祝福",
		"twentyK": "两万。你不再是一只兔子。你就是那只兔子。",
		"singularity": "兔子奇点。所有兔子都是你。你就是所有兔子。",
		"tripleAscension": "宇宙之兔的三重升天！",
		"ultimateAnswer": "42,000 - 终极答案从一开始就是胡萝卜",
		"eternity": "♾️ 永恒的兔子洞没有尽头。你也是。♾️"
	},
	"powerups": {
		"bonusPoints": "🥕 +{{count}} 奖励分数！",
		"clickStreak": "🔥 {{count}}连击！",
		"fire": "🔥 火焰力量激活！"
	},
	"table": {
		"achievement": "成就",
		"progress": "进度"
	},
	"reset": {
		"confirm": "确定要重置所有进度吗？此操作无法撤消。"
	}
}
